export default __webpack_public_path__ + "static/media/image.thyaga.4145e575.png";